import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import LinkText from '../../atoms/link-text/link-text';
import {
  OETextInput,
  OETextInputProps,
} from '../../atoms/oe-text-input/oe-text-input';
import { OETextInputSecure } from '../../atoms/oe-text-input-secure/oe-text-input-secure';
import { TestId } from '../../constants/test-id';

export type TextInputWithLinkProps = OETextInputProps & {
  linkText?: string;
  onLinkPress?: () => void;
  secure?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
};

export const TextInputWithLink = ({
  linkText,
  onLinkPress,
  secure,
  containerStyle,
  testID,
  ...props
}: TextInputWithLinkProps) => (
  <View style={containerStyle}>
    {secure ? (
      <OETextInputSecure
        {...props}
        testID={`${testID}-${TestId.TEXT_INPUT_SECURED}`}
      />
    ) : (
      <OETextInput {...props} testID={`${testID}-${TestId.TEXT_INPUT}`} />
    )}
    {linkText && onLinkPress ? (
      <LinkText
        label={linkText}
        onPress={onLinkPress}
        testID={`${testID}-${TestId.LINK_TEXT}`}
      />
    ) : null}
  </View>
);

export default TextInputWithLink;
